<template>
  <v-layout row wrap>
    <v-col cols :sm="12" class="pa-0">
      <v-card v-show="!HashTag.isForm" flat class="pa-2 text-no-wrap">
        <v-data-table
          dense
          must-sort
          fixed-header
          item-key="id"
          :items="HashTag.list"
          :options.sync="pagings"
          :headers="cTableHeaders"
          :server-items-length="HashTag.total"
          :items-per-page="HashTag.filter.limit"
          :footer-props="{ itemsPerPageOptions: HashTag.itemPages }"
          :item-class="(e) => (id == e.id ? 'primary lighten-5' : '')"
        >
          <template v-slot:top>
            <v-layout px-2 justify-space-around align-end>
              <v-layout align-center>
                <h2>{{ $t("menu.hashtag") }}</h2>
                <v-btnc
                  :size="30"
                  icon="mdi-plus"
                  @click="
                    fnCallCreateView(model);
                    _fnLoadData();
                  "
                  v-if="fnCheckMission(Session, [{ m: HASHTAG, p: CREATE }])"
                />
              </v-layout>
              <v-spacer />
              <div class="mb-3" :style="{ width: '250px' }">
                <v-text-field
                  dense
                  single-line
                  hide-details
                  v-model="HashTag.search"
                  @keydown.enter="_fnSearch"
                  :placeholder="$t(`table.search`)"
                />
              </div>
            </v-layout>
          </template>
          <template #[`item.action`]="{ item }">
            <v-btnc
              color="warning"
              icon="mdi-pencil"
              @click="
                fnCallUpdateView({ model, item: item });
                _fnLoadData();
              "
              v-if="fnCheckMission(Session, [{ m: HASHTAG, p: UPDATE }])"
            />
            <v-btnc
              color="error"
              icon="mdi-delete"
              @click="fnCallDeleteView({ model, item: item })"
              v-if="fnCheckMission(Session, [{ m: HASHTAG, p: DELETE }])"
            />
          </template>
          <template #[`item._id`]="{ item }"> {{ item.id }}<br /> </template>
          <template #[`item.isTrend`]="{ item }">
            <span :class="item.isTrend ? 'success--text' : 'error--text'">
              {{ item.isTrend ? "Yes" : "No" }}
            </span>
          </template>
          <template #[`item.createdAt`]="{ item }">
            {{ item.createdAt | mDateTime }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <v-col cols :sm="12" class="pa-0"><v-dialog /></v-col>
  </v-layout>
</template>

<script>
import Dialog from "./dialog.vue";

export default {
  components: {
    "v-dialog": Dialog,
  },
  data() {
    return {
      id: "",
      model: "HashTag",
      pagings: {},
    };
  },
  computed: {
    cTableHeaders() {
      let table = [
        {
          text: this.$t(`table.action`),
          sortable: false,
          value: "action",
          width: "10px",
        },
        {
          text: this.$t(`table.id`),
          value: "_id",
          width: "10px",
        },
        {
          text: this.$t(`table.name`),
          value: "name",
        },
        {
          text: this.$t(`table.post`),
          value: "numberOfPost",
          width: "10px",
        },
        {
          text: this.$t(`table.trend`),
          value: "isTrend",
          width: "10px",
        },
        {
          text: this.$t(`table.priority`),
          value: "priority",
          width: "10px",
        },
        {
          text: this.$t(`table.createdAt`),
          value: "createdAt",
          width: "10px",
        },
      ];
      return table;
    },
  },
  watch: {
    "HashTag.isRefresh": function (val) {
      if (val) {
        this._fnCallListView();
      }
    },
    pagings: function (val) {
      const { itemsPerPage, page, sortBy, sortDesc } = val;
      this[this.model].filter.limit = itemsPerPage;
      this[this.model].filter.page = page;
      if (sortBy.length) {
        this[this.model].filter.sort = `${sortBy[0]}:${sortDesc[0] ? -1 : 1}`;
      }
      this._fnCallListView();
    },
  },
  methods: {
    _fnLoadData() {
      if (this[this.model].isCreate) {
        this[this.model].obj = { priority: 1 };
      } else if (this[this.model].isUpdate) {
        this.id = this[this.model].obj.id;
        this[this.model].obj = { ...this[this.model].obj };
      }
    },
    _fnCallListView() {
      this.fnCallListView({
        url: "/v1/admin/hashtag",
        model: this.model,
      });
    },
    _fnSearch({ target: { value } }) {
      if (!value) delete this[this.model].filter.$text;
      else this[this.model].filter.$text = value;
      this._fnCallListView();
    },
  },
};
</script>
